import insurancePickerSelector from '@zocdoc/components/src/InsurancePicker/data/insurancePickerSelector';
import { get, flowRight } from 'lodash';
import { connect } from 'react-redux';
import withInsuranceValidation from '../../../../gql/withInsuranceValidation';
import { clickChangeInsurance, clickBookAnyway } from '../../../../Shared/Modals/addInsuranceModal/actions';
import withViewportDetection from '../../../../config/viewport';
import { changeInsurance } from '../../actions';
import { getProfilePageParameters } from '../../state/selectors';
import { showInsuranceDetails, hideInsuranceDetails, trackClickShowInNetworkDoctors } from './actions';
import InlineInNetworkInsuranceView from './InlineInNetworkInsurance';
import inNetworkInsurancesSelector from './selector';

const mapStateToProps = (state, ownProps) => {
    const parameters = inNetworkInsurancesSelector(state);
    const insurancePickerState = insurancePickerSelector(state) || { };
    const carrierName = get(insurancePickerState, 'dropdownState.carrier.name', '');
    const planName = get(insurancePickerState, 'dropdownState.plan.name', '');
    const profilePageParameters = getProfilePageParameters(state);

    return {
        bookingSpotlightIsOn: profilePageParameters.bookingSpotlightIsOn,
        carrierId: insurancePickerState.carrier,
        carrierName,
        detailsVisible: parameters.detailsVisible,
        initParameters: profilePageParameters.initParameters,
        planId: insurancePickerState.plan,
        planName,
        providerId: ownProps.provider.id,
    };
};

const mapDispatchToProps = {
    changeInsurance,
    clickBookAnyway,
    clickChangeInsurance,
    hideInsuranceDetails,
    showInsuranceDetails,
    trackClickShowInNetworkDoctors,
};

export const InlineInNetworkInsurance = flowRight(
    connect(mapStateToProps, mapDispatchToProps),
    withInsuranceValidation,
    withViewportDetection
)(InlineInNetworkInsuranceView);
